/**
 * Purpose: Mask whole-word profanity in transcript text before Kafka publish.
 * Non-goals: Does not change Whisper STT, LiveKit room chat, or bot behavior.
 * Invariants: Always applied on publish; uses @2toad/profanity English dictionary.
 */
import { CensorType, Profanity } from "@2toad/profanity";

function createFilter(): Profanity {
    const filter = new Profanity({
        languages: ["en"],
        wholeWord: true,
        grawlix: "[unintelligible]",
    });
    return filter;
}

/**
 * Replaces whole-word profanity with [unintelligible] for Kafka/export consumers.
 * Always runs; there is no disable flag.
 */
let defaultFilter: Profanity | undefined;
function getFilter(): Profanity {
    if (!defaultFilter) {
        defaultFilter = createFilter();
    }
    return defaultFilter;
}

export function maskTranscriptProfanity(text: string): string {
    return getFilter().censor(text, CensorType.Word);
}
